var _a;
import { Text } from 'wix-style-react';
import * as React from 'react';
import css from './RecurringPayView.scss';
export var frequencyTranslations = (_a = {},
    _a["daily" /* BillingCycle.DAILY */] = 'invoice.recurring.email.billing-frequency.daily',
    _a["weekly" /* BillingCycle.WEEKLY */] = 'invoice.recurring.email.billing-frequency.weekly',
    _a["fortnightly" /* BillingCycle.FORTNIGHTLY */] = 'invoice.recurring.email.billing-frequency.fortnightly',
    _a["monthly" /* BillingCycle.MONTHLY */] = 'invoice.recurring.email.billing-frequency.monthly',
    _a["yearly" /* BillingCycle.YEARLY */] = 'invoice.recurring.email.billing-frequency.yearly',
    _a);
export var RecurringPayView = function (_a) {
    var t = _a.t, invoice = _a.invoice, currency = _a.currency;
    var total = invoice.total, _b = invoice.metaData.sourceProperties, billingCycle = _b.billingCycle, numberOfBillingCycles = _b.numberOfBillingCycles, frequency = _b.frequency;
    var isUnlimitedBilling = numberOfBillingCycles === '0';
    return (React.createElement("div", { "data-hook": "recurring-pay-view", className: css.container },
        React.createElement(Text, { weight: "bold" }, "".concat(t('recurring-payment-uou.title'), " "),
            isUnlimitedBilling
                ? t('recurring-payment-uou.title.unlimited', { billingCycle: billingCycle })
                : t('recurring-payment-uou.title.limited', {
                    billingCycle: billingCycle,
                    numberOfBillingCycles: numberOfBillingCycles,
                }),
            React.createElement("br", null)),
        React.createElement(Text, { size: "small" }, t('invoice.recurring.pay.view.text', {
            total: currency(total),
            frequency: t(frequencyTranslations[frequency.toLocaleLowerCase()]),
        }))));
};
//# sourceMappingURL=RecurringPayView.js.map